<template>
  <div class="center">
    <LoadingLightIcon></LoadingLightIcon>
  </div>
</template>

<script>
import { LoadingLightIcon } from '@mikmak/components';

export default {
  components: {
    LoadingLightIcon,
  },
};
</script>
<style scoped>
  .center {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    left: 50%;
  }
</style>

